import { postFoDetailWithRetry } from './foDetailRequest';

/**
 * Fetch Smart Card display values from VDS for a filter context.
 *
 * POSTs a PerformanceMetricsRequestDto (same shape as /tbl/perf-mats-vds) to
 * /tbl/sc-vds and returns an array of smart cards whose pmpm, estimatedSavings,
 * reachImpactPct, costTrend and quartile are computed from VDS.
 *
 * @param {Object} body PerformanceMetricsRequestDto
 * @returns {Promise<Array>} smart cards with VDS-derived display fields
 */
export async function getSmartCardsVds(body) {
  return postFoDetailWithRetry('/tbl/sc-vds', body);
}
